export class ItemNumber {
  [key: string]: any;
  id: string = "";
  crtNumber: string = "";
  drawNumber: string = "";
  omfShortDescr: string = "";
  typeIdNum: string = "";
  productCategory: string = "";
  itemSubData: string = "";
  dinCode: string = "";
  dinText: string = "";
  artNumber: string = "";
  changeClasses: string[] = [];
  replmanfItemnumber: string = "";
  itemSOP: number = 0;
  itemEOP: number = 0;
  itemEOS: number = 0;
  itemLTD: number = 0;
  itemEOSR: number = 0;
}
